import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bidiFix',
  pure: true
})
export class BidiFixPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return value;

    const match = value.match(/^(.*)\s\((.*)\)$/);

    if (!match) {
      return value;
    }

    const name = match[1].trim();      
    const source = match[2].trim();   
    const RLE = '\u202B'; 
    const PDF = '\u202C'; 

    return `${RLE}${name}${PDF} (${RLE}${source}${PDF})`;
  }
}
